module.exports = __webpack_public_path__ + "img/logo_yahoo_news.2b26b191.png";